import ajax from "./ajax";

export function addOpportuneInfo(data) {
  return ajax({
    url: '/businessOpportune/addOpportuneInfo',
    data
  });
}

export function queryNotice(data) {
  return ajax({
    url: '/userNotice/pageQueryNotice',
    data
  });
}

export function queryNoticeDetail(data) {
  return ajax({
    url: '/userNotice/queryNoticeDetail',
    data
  });
}

export function getApiCategories() {
  return ajax({
    url: '/doc/queryApiCategory',
    data: {
      categoryParentId: 1,
    }
  });
}

export function getApiArticles(data) {
  return ajax({
    url: '/doc/queryApiDocList',
    data
  });
}

export function getApiArticlesNew(data) {
  return ajax({
    url: '/cms/category/queryChildCategoryTree',
    data
  });
}

export function getApiArticleDetail(data) {
  return ajax({
    url: '/doc/queryApiDocDetail',
    data
  });
}

export function getGuideCategories() {
  return ajax({
    url: '/cms/category/queryChildCategoryList',
    data: {
      categoryParentId: 2,
    }
  });
}

export function getFAQCategories() {
  return ajax({
    url: '/cms/category/queryChildCategoryList',
    data: {
      categoryParentId: 3,
    }
  });
}

export function getGuideArticles(data) {
  return ajax({
    url: '/cms/article/pageArticleGeneralByCategory',
    data
  });
}

export function getFAQCategoriesNew(data) {
  return ajax({
    url: '/cms/category/queryChildCategoryListNew',
    data
  });
}

export function getQuestionContentList(data) {
  return ajax({
    url: '/cms/article/queryQuestionContentList',
    data
  });
}

export function getFAQArticles(data) {
  return ajax({
    url: '/cms/article/pageArticleGeneralByCategory',
    data
  });
}

export function getGuideArticleDetail(data) {
  return ajax({
    url: '/cms/article/queryArticleDetailSingle',
    data
  });
}

export function getFAQArticleDetail(data) {
  return ajax({
    url: '/cms/article/queryArticleDetailSingle',
    data
  });
}

export function readContentAdd(data) {
  return ajax({
    url: '/cms/article/readContentAdd',
    data
  });
}

//新增管理控制台接口
export function getAppList(data) {
  //获取应用列表的接口
  return ajax({
    url: '/operaApp/queryAppList',
    data
  });
}
export function queryCreateApp(data) {
  //创建应用接口
  return ajax({
    url: '/operaApp/createApp',
    data,
    handled: true
  });
}
export function queryAppSecret(data) {
  //查看AppSecret
  return ajax({
    url: '/appSecret/queryAppSecret',
    data
  });
}
export function modifyAppInfo(data) {
  //修改应用名称
  return ajax({
    url: '/operaApp/modifyAppInfo',
    data
  });
}

export function queryAppRsaKey(data) {
  //下载RSA文件
  return ajax({
    url: '/appSecret/queryAppRsaKey',
    data
  });
}
export function linkContract(data) {
  //关联合同
  return ajax({
    url: '/operaApp/linkContract',
    data,
    handled: true
  });
}
export function queryAuthPackList(data) {
  //应用权限
  return ajax({
    url: '/appPack/queryAuthPackList',
    data: {
      ...data,
      openStateType: 1
    }
  });
}

//获取登录信息
export function getUserInfo() {
  return ajax({
    url: '/queryLoginInfo',
    method: 'get',
    handled: true
  });
}

/*
消息通知
*/
//查询通知未知数
export function unReadNotifyCount(data) {
  return ajax({
    url: '/userNotify/unReadNotifyCount',
    data
  });
}
//查询通知列表
export function pageQueryMsg(data) {
  return ajax({
    url: '/userNotify/pageQueryMsg',
    data
  });
}
//转换读状态
export function switchReadState(data) {
  return ajax({
    url: '/userNotify/switchReadState',
    data
  });
}
export function queryDownJosSdkInfo(data) {
  //下载sdk
  return ajax({
    url: '/appSdk/queryDownJosSdkInfo',
    data,
    timeout: 10000
  });
}
export function queryAuthPackSingle(data) {
  //权限详情
  return ajax({
    url: '/appPack/queryAuthPackSingle',
    data
  });
}
export function queryAppBaseInfo(data) {
  //单个应用
  return ajax({
    url: '/operaApp/queryAppBaseInfo',
    data
  });
}
export function deleteApp(data) {
  //删除应用
  return ajax({
    url: '/operaApp/deleteApp',
    data
  });
}

//对接帮助详情
export function queryLimitPackageDetail(data) {
  return ajax({
    url: '/cms/package/queryLimitPackageDetail',
    data
  });
}
//对接帮助列表
export function queryLimitPackageList(data) {
  return ajax({
    url: '/cms/package/queryLimitPackageList',
    data
  });
}

//消息订阅
export function queryClientMsgInfoList(data) {
  return ajax({
    url: '/msgType/queryClientMsgInfoList',
    data
  });
}
//开通/取消订阅
export function applyAccessChoose(data) {
  return ajax({
    url: '/msgType/applyAccessChoose',
    data
  });
}

//白名单管理
export function queryTrafficPermissionList(data) {
  return ajax({
    url: '/ipWhite/queryIpWhiteList',
    data
  });
}

//白名单全量操作（新增和删除）
export function modifyIpWriteList(data) {
  return ajax({
    url: '/ipWhite/modifyIpWriteList',
    data
  });
}
//查询权限包接口
export function appPackqueryAuthPackList(data) {
  return ajax({
    url: '/appPack/queryAuthPackList',
    data
  });
}
//申请权限包
export function switchAuthPack(data) {
  return ajax({
    url: '/appPack/switchAuthPack',
    data
  });
}

// 查询组件订阅分类数量
export function queryComponentCount(data) {
  return ajax({
    url: '/component/queryComponentCount',
    data
  });
}
// 查询组件订阅列表
export function queryComponentList(data) {
  return ajax({
    url: 'component/queryComponentList',
    data
  });
}
// 订阅组件
export function subComponent(data) {
  return ajax({
    url: 'component/subComponent',
    data
  });
}
// 查询组件订阅配置列表
export function queryComponentConfig(data) {
  return ajax({
    url: 'component/queryComponentConfig',
    data
  });
}
// 查询提交后的配置项
export function querySubmitComponentConfig(data) {
  return ajax({
    url: 'component/querySubmitComponentConfig',
    data
  });
}
// 上传接口
export function queryComponentUpload(data) {
  // return ajax({
  //   url: 'component/upload',
  //   data
  // });
  // let baseURL = "http://vop.jd.local/api";
  let baseURL = "/api";
  let url = baseURL + "/component/upload";
  return url;
}
// 审核驳回原因
export function queryRejectReason(data) {
  return ajax({
    url: 'component/queryRejectReason',
    data
  });
}
// 取消订阅
export function cancelComponent(data) {
  return ajax({
    url: 'component/cancelComponent',
    data
  });
}

export function searchNormalMsgByOpenPortal(data) {
  return ajax({
    url: '/msgLog/searchNormalMsgByOpenPortal',
    data
  });
}

//意见反馈
export function getFeedBackUrl() {
  return ajax({
    url: '/feedBack/getUrl',
    method: 'get'
  })
}
//白皮书轮播入口
export function queryIndexBool() {
  return ajax({
    url: '/cms/plan/queryIndexBool',
    method: 'get'
  })
}
//方案列表
export function queryPlanList() {
  return ajax({
    url: '/cms/plan/queryPlanList',
    method: 'get'
  })
}
//Api测试工具接口
export function queryRequestResult(data) {
  return ajax({
    url: 'tool/queryRequestResult',
    method: 'post',
    data
  })
}

//搜索类别列表
export function querySearchTypes(data) {
  return ajax({
    url: 'tool/searchTypes',
    method: 'post',
    data
  })
}

// 搜索
export function queryCommonSearch(data) {
  return ajax({
    url: 'tool/commonSearch',
    method: 'post',
    data
  });
}

// 修改密码
export function updatePassword(data) {
  return ajax({
    url: 'updatePassword',
    method: 'post',
    data
  });
}

//获取登录信息
export function getSurveyInfo() {
  return ajax({
    url: '/querySurveyInfo',
    method: 'post',
    handled: true
  });
}

/* 组件中心 */

/* 首页API */
// 首页客户案例
export function queryClientCase(data) {
  return ajax({
    url: '/componentCenter/queryClientCase',
    data
  });
}

/* 列表页API */
// 查询组件所有分类
export function queryComponentGroup(data) {
  //删除应用
  return ajax({
    url: '/componentCenter/queryComponentGroup',
    data
  });
}
// 查询该分类下的组件列表
export function queryComponentListByGroupId(data) {
  return ajax({
    url: '/componentCenter/queryComponentListByGroupId',
    data
  });
}

/* 组件详情页 */
/* 组件详情API */
// 组件详情API
export function queryComponentDetailByIndexName(data) {
  return ajax({
    url: '/componentCenter/queryComponentDetailByIndexName',
    data
  });
}
// 组件详情页——帮助与支持API
export function queryComponentHelpAndSupport(data) {
  return ajax({
    url: '/componentCenter/queryComponentHelpAndSupport',
    data
  });
}